export const DASHBOARD_DISPLAY_TYPE = {
  DASHBOARD_1: 'dash_1',
  DASHBOARD_2: 'dash_2',
  DASHBOARD_3: 'dash_3',
  DASHBOARD_4: 'dash_4',
  DASHBOARD_5: 'dash_5',
  DASHBOARD_6: 'dash_6',
  DASHBOARD_7: 'dash_7',
}
